import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';
import { semantic_colors } from '../../foundation';
import { Stack } from '../stack';
import { BaseText } from '../text';
import { Category } from './types';
import { ListItem } from './ListItem';
import { useProviderConfig } from '../provider';

export interface ListProps {
  level: number;
  categories: Array<Category>;
  selectedKeys: Array<string>;
  onSelect: (category: Category) => void;
  onClick: (category: Category) => void;
  isSelected: (category: Category) => boolean;
  isChecked: (category: Category) => boolean;
  isIndeterminate: (category: Category) => boolean;
  multiple?: boolean;
  disabled?: boolean;
}

export const List = ({
  level,
  categories,
  selectedKeys,
  onSelect,
  onClick,
  isSelected,
  isChecked,
  isIndeterminate,
  multiple,
  disabled,
}: ListProps) => {
  const { locale } = useProviderConfig();
  return (
    <Stack
      direction='column'
      className='pds-category-selector-list'
      css={css`
        flex: 1;
        &:not(:first-of-type) {
          border-left: 1px solid ${semantic_colors.border.primary};
        }
      `}
    >
      <Header>
        {level}
        {locale?.CategorySelector.levelCategory}
      </Header>
      <Article direction='column' align='center' height='100%'>
        {categories.length > 0 ? (
          categories.map((category) => (
            <ListItem
              key={category.key}
              category={category}
              selectedKeys={selectedKeys}
              onSelect={onSelect}
              onClick={onClick}
              isSelected={isSelected}
              isChecked={isChecked}
              isIndeterminate={isIndeterminate}
              multiple={multiple}
              disabled={disabled}
            />
          ))
        ) : (
          <Stack direction='row' height='100%' align='center'>
            <BaseText alignment='center' typography='Body_13_Regular' color={semantic_colors.content.secondary}>
              {locale?.CategorySelector.selectParentCategoryLine1}
              <br />
              {locale?.CategorySelector.selectParentCategoryLine2}
            </BaseText>
          </Stack>
        )}
      </Article>
    </Stack>
  );
};

const Header = styled(BaseText)`
  padding: 12px 16px;
  background: ${semantic_colors.fill.tertiary};
  border-bottom: 1px solid ${semantic_colors.border.primary};
`;

const Article = styled(Stack)`
  overflow-y: auto;
`;
